<template>
</template>

<script>
import router from '../router/index.js';
import { firebase } from '../firebase-config.js'

  export default {
    name: 'login',
    data: function() {
      return {
        email: '',
        password: ''
      }
    },
    created() {
      firebase.auth().signOut().then(function() {
        router.push({ path: 'login' })
      }, function(error) {
          this.$notify.error({
            title: 'Error',
            message: err.message
          });
      });
    }
  }
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
body {
  background: #3a3f51 !important;
}
  .login {
    margin-top: 40px;
    border-radius: 4px;
    width: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-70%);
  }
  .login-inner {
    background: #fff;
    width: 350px;
    margin: 0 auto;
    padding: 20px;
    box-shadow: 7px 10px 101px 0px rgba(0,0,0,0.15);
  }

  .el-input {
    margin-top: 10px;
  }
  input {
    margin: 10px 0;
    width: 100%;
    padding: 15px;
  }
  button {
    margin-top: 20px;
    width: 100%;
    cursor: pointer;
  }
  p {
    margin-top: 40px;
    font-size: 13px;
  }
  p a {
    text-decoration: underline;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// Logout.vue?cbfcbaee